export default "__VITE_ASSET__DZI6v_oh__"